import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: 100%;
	padding: 20px;
`;

export const Title = styled.h1`
	font-size: 24px;
	font-weight: bold;
	margin-top: 20px;
	margin-bottom: 40px;
	text-align: center;
	color: #333;
`;

export const SubTitle = styled.h2`
	font-size: 18px;
	//font-weight: bold;
	margin-top: 10px;
	margin-bottom: 10px;
	text-align: center;
	color: #333;
`;

export const Guide = styled.h2`
	font-size: 13px;
	//font-weight: bold;
	margin-top: 10px;
	margin-bottom: 10px;
	text-align: center;
	color: #333;
`;

export const Caption = styled.div`
	color: blue;
	font-size: 14px;
	margin-bottom: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

export const ButtonContainer = styled.div`
	margin: 0 auto;
	max-width: 800px;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 15px;
`;

export const InfoContainer = styled.div`
	margin: 5rem auto;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-content: start;
	background-color: white;
	border-radius: 12px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	padding: 10px 30px;
	& > h2 {
		text-align: start;
	}
`;

export const PersonaButton = styled.button`
	width: 250px;
	height: 100px;
	padding: 15px;
	border-radius: 10px;
	border: none;
	background-color: #ffffff;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
		background-color: #f0f0f0;
	}
`;

export const PersonaName = styled.div`
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 8px;
	color: #2c3e50;
`;

export const PersonaDesc = styled.div`
	font-size: 12px;
	color: #7f8c8d;
	text-align: center;
	line-height: 1.4;
`;

export const FeedbackButton = styled.button`
	background: linear-gradient(45deg, #ff6b6b, #ff8e8e);
	color: white;
	border: none;
	padding: 4px 16px;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	gap: 8px;
	margin-left: 12px;
	transition: all 0.2s ease-in-out;
	box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);
		background: linear-gradient(45deg, #ff8e8e, #ffa5a5);
	}

	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);
	}

	span {
		font-size: 16px;
	}
`;
